import React, { useMemo } from 'react';
import DynamicsDetailPage from '../DynamicsDetailPage';
import { getApiV1Url } from '../config/api';
import axios from 'axios';
import { Certif } from '../CertificatesPage';

interface DynamicsManufacturersPageProps {
    filteredCertif?: Certif[];
}

const DynamicsManufacturersPage: React.FC<DynamicsManufacturersPageProps> = ({ filteredCertif: propFilteredCertif }) => {
    const [certif, setCertif] = React.useState<Certif[]>([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        if (propFilteredCertif !== undefined) {
            setCertif(propFilteredCertif);
            setLoading(false);
        }
    }, [propFilteredCertif]);
    
    React.useEffect(() => {
        if (propFilteredCertif !== undefined) {
            return;
        }
        
        const fetchData = async () => {
            try {
                const access = localStorage.getItem('access');
                const response = await axios.get<Certif[]>(getApiV1Url('CERTIFICATES'), {
                    headers: { Authorization: `Bearer ${access}` },
                });
                setCertif(response.data);
            } catch (error) {
                console.error('Error fetching certificates:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const filteredCertif = propFilteredCertif !== undefined ? propFilteredCertif : certif;

    const manufacturerMaps = useMemo(() => {
        const nameToInn = new Map<string, string>();
        const innToName = new Map<string, string>();
        for (const item of filteredCertif) {
            const inn = (item.manufacture_inn || '').trim();
            const name = (item.manufacture_fullname || '').trim();
            if (!inn || !name || name.toLowerCase() === 'отсутствует' || /^\d{10,}$/.test(name)) continue;
            if (!innToName.has(inn)) innToName.set(inn, name);
            if (!nameToInn.has(name)) nameToInn.set(name, inn);
        }
        return { nameToInn, innToName };
    }, [filteredCertif]);

    const getDynamicsData = useMemo(() => {
        return () => {
            const manufacturerCounts = new Map<string, Map<string, number>>();
            filteredCertif.forEach(item => {
                if (!item.cert_reg_data) return;
                const year = String(item.cert_reg_data.substring(0, 4));
                if (!manufacturerCounts.has(year)) manufacturerCounts.set(year, new Map());
                const m = manufacturerCounts.get(year)!;
                const inn = (item.manufacture_inn || '').trim();
                if (!inn) return;
                let name = manufacturerMaps.innToName.get(inn);
                if (!name) {
                    const rawName = (item.manufacture_fullname || '').trim();
                    name = rawName && rawName.toLowerCase() !== 'отсутствует' && !/^\d{10,}$/.test(rawName) ? rawName : inn;
                }
                m.set(name, (m.get(name) || 0) + 1);
            });
            const manufacturerNames = Array.from(new Set(Array.from(manufacturerCounts.values()).flatMap(m => Array.from(m.keys())))).sort();
            const years = Array.from(new Set(filteredCertif.map(i => i.cert_reg_data ? i.cert_reg_data.substring(0,4) : '').filter(Boolean))).sort();
            return { years, names: manufacturerNames, counts: manufacturerCounts };
        };
    }, [filteredCertif, manufacturerMaps]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                Загрузка...
            </div>
        );
    }

    return (
        <DynamicsDetailPage
            getDynamicsData={getDynamicsData}
            title="Изготовители - Динамика"
            chartTitle="Динамика сертификатов по изготовителям"
            maps={manufacturerMaps}
        />
    );
};

export default DynamicsManufacturersPage;

